import { Link, useHistory, useParams } from 'react-router-dom';

import { BaseURL } from '../../../../../base/env';
import FilterSort from '../../../../components/CategoryBar/FilterSort/FilterSort';
import sub_no_name from './../../../../../assets/images/icons/sub-no-name.png';
import { ReactComponent as BottomArrow } from './../../../../../assets/svg/bottom-arrow.svg';
import styles from './CategoryBar.module.css';

export const getSortedParams = (params) =>
  [
    params.id || null,
    params.sub || null,
    params.c3 || null,
    params.c4 || null,
    params.c5 || null,
    params.c6 || null
  ].filter((catItem) => catItem !== null);

const CategoryBar = ({
  categories,
  showFilterSort = false,
  activeCategory,
  withoutUrl
  // page = '',
}) => {
  // const location = useLocation();
  const history = useHistory();
  const params = useParams();
  const paramsArray = getSortedParams(params);

  if (!categories) {
    return null;
  }

  const SubList = categories.find((catItem) => {
    if (withoutUrl) {
      return catItem.id.toString() === (activeCategory || '').toString();
    }
    return catItem.id.toString() === paramsArray[paramsArray.length - 1];
  });

  if (!SubList || !SubList.sub_categories) {
    return null;
  }

  return (
    <div className={styles.CategoryBarContainer}>
      {categories ? (
        <div className={`${styles.ParentListContainer}`}>
          <div className={styles.ParentList}>
            {categories.map((pitem) => {
              const isActive = activeCategory.toString() === pitem.id.toString();
              const hasCategoryPageParams = params.id && params.sub && params.c3;
              const getUrlByParams = (isNotAll) => {
                if (isNotAll) {
                  if (paramsArray.length > 3) {
                    return pitem.has_homepage
                      ? `/category${paramsArray
                          .filter((param) => param !== paramsArray[paramsArray.length - 1])
                          .map((pitem2) => `/${pitem2}`)
                          .join('')}/${pitem.id.toString()}`
                      : `/category${paramsArray.map((pitem3) => `/${pitem3}`).join('')}/${pitem.id.toString()}/${pitem.id.toString()}`;
                  }

                  return pitem.has_homepage
                    ? `/category/${paramsArray[0]}/${pitem.parent.id.toString()}/${pitem.id.toString()}`
                    : `/category/${paramsArray[0]}/${pitem.parent.id.toString()}/${pitem.id.toString()}/${pitem.id.toString()}`;
                }
                if (hasCategoryPageParams) {
                  if (paramsArray.length > 3) {
                    const newParams = paramsArray.filter(
                      (param) => param !== paramsArray[paramsArray.length - 1]
                    );
                    if (pitem.has_homepage) newParams.splice(-1);
                    return pitem.has_homepage
                      ? `/category${newParams.map((pitem4) => `/${pitem4}`).join('')}/${pitem.id.toString()}`
                      : `/category${newParams.map((pitem5) => `/${pitem5}`).join('')}/${pitem.id.toString()}/${pitem.id.toString()}`;
                  }

                  return pitem.has_homepage
                    ? `/category/${paramsArray[0]}/${pitem.id.toString()}`
                    : `/category/${paramsArray[0]}/${pitem.id.toString()}/${pitem.id.toString()}`;
                }
                return pitem.has_homepage
                  ? `/category/${paramsArray[0]}/${paramsArray[1]}/${pitem.id.toString()}`
                  : `/category/${paramsArray[0]}/${paramsArray[1]}/${pitem.id.toString()}/${pitem.id.toString()}`;
              };
              return (
                <Link
                  key={pitem.id}
                  className={`${styles.ParentItem} ${isActive ? styles.Active : ''}`}
                  to={
                    paramsArray[paramsArray.length - 1] === paramsArray[paramsArray.length - 2]
                      ? getUrlByParams()
                      : getUrlByParams(true)
                  }>
                  {pitem.name}
                </Link>
              );
            })}
          </div>
        </div>
      ) : null}
      {categories ? (
        <div className={`${styles.SubListContainer} ${styles.HasReturn}`}>
          <div className={styles.SubList}>
            {SubList.sub_categories.map((subItem) => {
              const isActive =
                subItem.has_homepage &&
                paramsArray[paramsArray.length - 2] !== paramsArray[paramsArray.length - 1]
                  ? false
                  : paramsArray[paramsArray.length - 1].toString() === subItem.id.toString();
              const subParamsArray = getSortedParams(params);
              if (!isActive) {
                if (subItem.name !== 'همه') {
                  if (paramsArray.length > 3) {
                    subParamsArray.pop();
                  }
                  if (!subItem.has_homepage)
                    subParamsArray[subParamsArray.length] = subItem.id.toString();
                  subParamsArray.push(subItem.id.toString());
                } else {
                  subParamsArray.push(subItem.id.toString());
                }
                if (params.c3 === params.sub && params.sub !== subItem.id.toString()) {
                  subParamsArray.splice(1, 1);
                }
              }
              const newUrl = `/category${subParamsArray.map((pitem) => `/${pitem}`).join('')}`;

              return (
                <Link key={subItem.id} className={styles.SubItem} to={newUrl}>
                  <div
                    className={`${styles.SubItemImageContainer} ${isActive ? styles.Active : ''}`}>
                    <img
                      alt={subItem.name}
                      className={styles.SubItemImage}
                      src={subItem.image ? BaseURL + subItem.image : sub_no_name}
                    />
                  </div>
                  <span className={styles.SubItemText}>{subItem.name}</span>
                </Link>
              );
            })}
          </div>

          {/* Back Butoton */}
          <div
            className={`${styles.BackContainer} ${!withoutUrl ? styles.Active : ''}`}
            onClick={() => {
              // if (SubList?.has_homepage) {
              //     const subParamsArray = getSortedParams(params);
              //     subParamsArray.pop();
              //     const newUrl = `/${page}${subParamsArray.map(pitem => `/${pitem}`).join('')}${location.search}`;
              //     history.push(newUrl)
              // } else {
              //     history.push('/');
              // }
              history.goBack();
            }}>
            <BottomArrow className={styles.BottomArrow} />
          </div>
        </div>
      ) : null}
      {!!showFilterSort && !!activeCategory ? <FilterSort category_id={activeCategory} /> : null}
    </div>
  );
};

export default CategoryBar;
